import { ScreensToSectionMap } from './screens';

export function getGASectionFromUrl(url: string) {
  const section = ScreensToSectionMap[url];

  if (!section) {
    return;
  }

  return section;
}
